export default __webpack_public_path__ + "static/media/baseline.c1e78873.svg";